// Le misure delle scritte nella scheda della lezione chiusa (#214), che
// header, nomi e campo devono avere uguali. Erano 14px già prima: quello che
// la faceva sembrare grande erano gli spazi e i grassetti. Si sono stretti
// insieme, testi e spazi, perché un testo più piccolo nello spazio di prima
// galleggia; il nome resta la cosa più grande, e in grassetto.
export const CARD_TEXT = {
	// orario, tipo, il campo
	line: "13px",
	// chi c'è
	name: "16px",
	nameLine: "1.35rem",
	// come paga, chi paga il campo
	aside: "11px",
}
